import React from 'react';

import { Button, FontAwesomeIcon } from '@schoolinks/ui-components';
import { useSelector, useDispatch } from 'react-redux';

import { faVolume } from '@fortawesome/pro-solid-svg-icons/faVolume';

import TextToSpeechPlayAll from 'components/Common/LayoutV2/AppBar/TextToSpeech/components/TextToSpeechPlayAll';

import { TTS_PLAY_ALL } from 'modules/ElementaryCareers/constants';
import { SET_TTS_DATA } from 'modules/ElementaryCareers/store/actionTypes';

import s from './TextToSpeech.css';

const TextToSpeech = () => {
  const dispatch = useDispatch();
  const { ttsOption } = useSelector(state => state?.textToSpeech);

  const onClick = () => {
    const payload = {
      ttsOption: TTS_PLAY_ALL,
      playingItem: 0,
      isPlaying: false,
    };

    // Show TTS controls
    dispatch({
      type: SET_TTS_DATA,
      payload: {
        ttsOption: TTS_PLAY_ALL,
      },
    });

    // Start playing
    dispatch({
      type: SET_TTS_DATA,
      payload,
    });
  };

  if (ttsOption) {
    return <TextToSpeechPlayAll />;
  }

  return (
    <Button
      hasWhiteBackground={false}
      className={s.button}
      label="Read aloud"
      color="secondary"
      hasIconLeft
      variant="outlined"
      icon={<FontAwesomeIcon icon={faVolume} />}
      onClick={onClick}
    />
  );
};

export default TextToSpeech;
